import { FlexiButton } from '@flexinet/ui-components';
import { AiOutlineFilter } from 'react-icons/ai';
import { useState } from 'react';
import { Badge } from '@mantine/core';
import { FilterDrawer } from '../drawers/FilterDrawer';
import { usePipelinesFilter } from '../hooks/usePipelinesFilter';

export const FilterRecordButton = () => {
    const [opened, setOpened] = useState(false);
    const { filters } = usePipelinesFilter();

    const hasActiveFilters = Object.keys(filters).length > 0;

    return (
        <>
            <div style={{ position: 'relative' }}>
                <FlexiButton
                    leftSection={<AiOutlineFilter />}
                    onClick={() => setOpened(true)}
                >
                    Filter
                </FlexiButton>
                {hasActiveFilters && (
                    <Badge
                        size="xs"
                        variant="filled"
                        color="blue"
                        style={{
                            position: 'absolute',
                            top: -8,
                            right: -8,
                            minWidth: 16,
                            height: 16,
                            padding: 0,
                        }}
                    >
                        {Object.keys(filters).length}
                    </Badge>
                )}
            </div>
            <FilterDrawer
                opened={opened}
                onClose={() => setOpened(false)}
            />
        </>
    );
};
